var exports = {
  "kL": "x7f9a0e16--1434d7--container",
  "DD": "x7f9a0e16--1434d7--title",
  "os": "x7f9a0e16--1434d7--centered-title",
  "AS": "x7f9a0e16--1434d7--item",
};

module.exports = exports;
